import { render, staticRenderFns } from "./editor_novel.vue?vue&type=template&id=583e2b4f"
import script from "./editor_novel.vue?vue&type=script&lang=js"
export * from "./editor_novel.vue?vue&type=script&lang=js"
import style0 from "./editor_novel.vue?vue&type=style&index=0&id=583e2b4f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports